import { z } from "zod"

/**
 * Minimal line item shape from GET /cart.js (Cart AJAX API).
 * Extra fields are preserved via passthrough for forward compatibility.
 */
export const ShopifyAjaxCartLineItemSchema = z
  .object({
    variant_id: z.number(),
    // Cart AJAX returns all property values as strings (e.g. `_personalisation_choices` is a JSON string).
    properties: z.record(z.string(), z.unknown()).optional(),
  })
  .passthrough()

export type ShopifyAjaxCartLineItem = z.infer<typeof ShopifyAjaxCartLineItemSchema>

/**
 * Root cart payload from GET /cart.js.
 * Only `items` is required for gift-wrap logic; other keys pass through.
 */
export const ShopifyAjaxCartDataSchema = z
  .object({
    items: z.array(ShopifyAjaxCartLineItemSchema),
  })
  .passthrough()

export type ShopifyAjaxCartData = z.infer<typeof ShopifyAjaxCartDataSchema>
